import React, { useRef, useState, useEffect } from "react";
import SubPageTemplate from "./templates/SubPageTemplate";
import Hidden from "@material-ui/core/Hidden";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useTranslation, Trans } from "react-i18next";
import clsx from "clsx";
import Grid from "@material-ui/core/Grid";
import axios from "axios";
import { Container } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import SvgIcon from "@material-ui/core/SvgIcon";
import CancelIcon from "@material-ui/icons/Cancel";
import IconButton from "@material-ui/core/IconButton";
import { Link } from "react-router-dom";
import {
  profileAPI,
  headerAPI,
  _link,
  CDN_URI_BASE,
  numberWithCommas,
  hostingServices,
  generatePageURI,
  isValidImgURL,
  pagePaths
} from "../common/utilities";
import styles from "./ProfileManagerPage.module.scss";
import ActionButton from "../components/inputs/ActionButton";
import { duration } from "@material-ui/core/styles";

const imgType = {
  BANNER: 1,
  AVATAR: 2
};

function CancelButton({ onClick }) {
  return (
    <span className={styles.cancel_btn} onClick={onClick}>
      <CancelIcon />
    </span>
  );
}

function CurrentURL(props) {
  const { url, onClickCancelBtn, formDisabled } = props;
  const { t, i18n } = useTranslation();

  const currentURL = url ? url : t("The default image is displayed.");

  const handleClickCancelBtn = e => {
    onClickCancelBtn(e);
  };

  return (
    <div className={styles.current_url_container}>
      <span className={styles.current_url_text}>{currentURL}</span>
      {url && <CancelButton onClick={handleClickCancelBtn} />}
    </div>
  );
}

function PageContent(props) {
  const {
    mobile,
    usn,
    initialBannerURL = "",
    initialAvatarURL = "",
    data
  } = props;

  const { t, i18n } = useTranslation();

  const resultMsgEl = useRef(null);
  const bannerURLInputEl = useRef(null);
  const avatarURLInputEl = useRef(null);
  const hostingServicesEl = useRef(null);
  const resultMsgTimeoutDuration = 5000; //in ms

  const [bannerURLInput, setBannerURLInput] = useState("");
  const [avatarURLInput, setAvatarURLInput] = useState("");
  const [bannerURLInputErrMsg, setBannerURLInputErrMsg] = useState("");
  const [avatarURLInputErrMsg, setAvatarURLInputErrMsg] = useState("");
  const [bannerURLInputSuccess, setBannerURLInputSuccess] = useState(false);
  const [avatarURLInputSuccess, setAvatarURLInputSuccess] = useState(false);
  const [bannerURL, setBannerURL] = useState();
  const [avatarURL, setAvatarURL] = useState();
  const [resultMsg, setResultMsg] = useState();
  const [formDisabled, setFormDisabled] = useState(false);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogRemoveImgType, setDialogRemoveImgType] = useState();
  const [resultMsgTimeoutID, setResultMsgTimeoutID] = useState();

  useEffect(() => {
    setBannerURL(data.URL1_TEXT != null ? data.URL1_TEXT : "");
    setAvatarURL(data.URL2_TEXT != null ? data.URL2_TEXT : "");
  }, []);

  const handleOpenRemoveBannerDialog = e => {
    e.preventDefault();
    if (!formDisabled) {
      setDialogRemoveImgType(imgType.BANNER);
      setDialogOpen(true);
    }
  };

  const handleOpenRemoveAvatarDialog = e => {
    e.preventDefault();
    if (!formDisabled) {
      setDialogRemoveImgType(imgType.AVATAR);
      setDialogOpen(true);
    }
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setDialogRemoveImgType(null);
  };

  const handleRemoveImgTypeURL = () => {
    switch (dialogRemoveImgType) {
      case imgType.BANNER:
        //do ajax call submit
        submitURLs(null, "", null, () => {
          //on fail
          setBannerURLInputErrMsg("An error occured.");
          scrollToRef(bannerURLInputEl);
        });
        break;
      case imgType.AVATAR:
        submitURLs("", null, null, () => {
          //on fail
          setAvatarURLInputErrMsg(t("An error occured."));
          scrollToRef(avatarURLInputEl);
        });
        break;
    }
    setDialogRemoveImgType(null);
    setDialogOpen(false);
  };

  const handleBannerURLInputChange = e => {
    setBannerURLInput(e.target.value);
    setBannerURLInputErrMsg(null);
    setBannerURLInputSuccess(false);
  };

  const handleAvatarURLInputChange = e => {
    setAvatarURLInput(e.target.value);
    setAvatarURLInputErrMsg(null);
    setAvatarURLInputSuccess(false);
  };

  //paramters:
  //null - make input explicitly set to ''
  //'' - make input set to whatever currrentvalue is
  //<some value> - don't change input - setting as <some value>
  const submitURLs = async (
    newBannerURLInput,
    newAvatarURLInput,
    callbackSuccess,
    callbackFail
  ) => {
    const newBannerURL =
      newBannerURLInput == null
        ? ""
        : newBannerURLInput == ""
        ? bannerURL
        : newBannerURLInput;

    const newAvatarURL =
      newAvatarURLInput == null
        ? ""
        : newAvatarURLInput == ""
        ? avatarURL
        : newAvatarURLInput;

    setFormDisabled(true);

    //using axios.defaults... as workaround
    //https://github.com/axios/axios/issues/587
    //may want to move axios.defaults... to oncompmount
    // axios.defaults.withCredentials = true;
    let res = await axios.post(
      `${profileAPI}?command=profileURL&usn=${usn}&ribbon=${window._region === 'BR' ? 2 : 113}&bannerURL=${newBannerURL}&avatarURL=${newAvatarURL}`,
      { withCredentials: true }
    );

    if (res.data.APIresult == "000") {
      // setBannerURLInput("");
      // setAvatarURLInput("");
      setBannerURL(newBannerURL);
      setAvatarURL(newAvatarURL);
      callbackSuccess && callbackSuccess();
    } else {
      // success = false;
      callbackFail && callbackFail();
    }
    setFormDisabled(false);
  };

  const handleSubmit = e => {
    e.preventDefault();
    //reset error and sucesses
    setAvatarURLInputSuccess(false);
    setBannerURLInputSuccess(false);
    setBannerURLInputErrMsg(null);
    setAvatarURLInputErrMsg(null);

    let someInvalidURLs = false;

    //validation
    if (!bannerURLInput && !avatarURLInput) {
      showResultMsg(t("No URLs provided."));
      return false;
    }
    if (avatarURLInput && !isValidImgURL(avatarURLInput, hostingServices)) {
      //show message
      setAvatarURLInputErrMsg("Uploaded URL is not a valid image.");
      scrollToRef(avatarURLInputEl);
      someInvalidURLs = true;
    }
    if (bannerURLInput && !isValidImgURL(bannerURLInput, hostingServices)) {
      //show message
      setBannerURLInputErrMsg(t("Uploaded URL is not a valid image."));
      scrollToRef(bannerURLInputEl);
      someInvalidURLs = true;
    }
    if (someInvalidURLs) {
      return false;
    }

    //if we made it here, inputs are valid and ready for
    //submisson

    submitURLs(
      bannerURLInput,
      avatarURLInput,
      () => {
        //on success
        if (bannerURLInput) {
          setBannerURLInputSuccess(true);
        }
        if (avatarURLInput) {
          setAvatarURLInputSuccess(true);
        }
        showResultMsg(t("Images are updated successfully."));
        scrollToRef(resultMsgEl);
      },
      () => {
        //on any failure
        setBannerURLInputSuccess(false);
        setAvatarURLInputSuccess(false);
        if (avatarURLInput) {
          setAvatarURLInputErrMsg(t("An error occured."));
          scrollToRef(avatarURLInputEl);
        }
        if (bannerURLInput) {
          setBannerURLInputErrMsg(t("An error occured."));
          scrollToRef(bannerURLInputEl);
        }
      }
    );
  };

  const showResultMsg = msg => {
    clearTimeout(resultMsgTimeoutID);
    setResultMsg(msg);
    let tid = setTimeout(() => {
      setResultMsg(null);
    }, resultMsgTimeoutDuration);
    setResultMsgTimeoutID(tid);
    scrollToRef(resultMsgEl);
  };

  const preventDefault = e => {
    e.preventDefault();
  };

  //https://stackoverflow.com/questions/43441856/reactjs-how-to-scroll-to-an-element
  const scrollToRef = ref => window.scrollTo(0, ref.current.offsetTop); // General scroll to element function

  return (
    <Container
      maxWidth={"sm"}
      // classes={{ root: styles.page_container }}
    >
      <form onSubmit={handleSubmit}>
        {/* <fieldset disabled={formDisabled}> */}
        {/* https://stackoverflow.com/questions/3507958/how-can-i-make-an-entire-html-form-readonly/17186342#17186342 */}
        {/* <div className={styles.page_content}> */}
        <section className={styles.instructions}>
          <p>
            <Trans>Personalize your profile page right here! To update your Header Banner image and Profile image upload your images to a <span className={styles.supported_hosting} onClick={() => scrollToRef(hostingServicesEl)}>supported hosting service</span>. Copy the image URLs and paste them in the fields below.</Trans>
          </p>
        </section>
        <section>
          <h4>{t("Header Banner Image")}</h4>
          <CurrentURL
            url={bannerURL}
            onClickCancelBtn={handleOpenRemoveBannerDialog}
          />

          <div
            className={clsx(
              styles.input_container,
              bannerURLInputErrMsg && styles.error,
              bannerURLInputSuccess && styles.success
            )}
          >
            <input
              type="text"
              value={bannerURLInput}
              onChange={handleBannerURLInputChange}
              disabled={formDisabled}
              ref={bannerURLInputEl}
            />
            <p
              className={styles.url_error_msg}
              style={{ display: bannerURLInputErrMsg ? "block" : "none" }}
            >
              {bannerURLInputErrMsg}
            </p>
            <p className={styles.url_suggestion_msg}>
              {t("Recommended minimum size: 1920 x 300px.")}
              <br />
              {t("Only JPG, PNG, and GIF files are allowed.")}
            </p>
          </div>
        </section>
        <section>
          <h4>{t("Profile Image")}</h4>
          <CurrentURL
            url={avatarURL}
            onClickCancelBtn={handleOpenRemoveAvatarDialog}
          />
          <div
            className={clsx(
              styles.input_container,
              avatarURLInputErrMsg && styles.error,
              avatarURLInputSuccess && styles.success
            )}
          >
            <input
              type="text"
              value={avatarURLInput}
              onChange={handleAvatarURLInputChange}
              disabled={formDisabled}
              ref={avatarURLInputEl}
            />
            <p
              className={styles.url_error_msg}
              style={{ display: avatarURLInputErrMsg ? "block" : "none" }}
            >
              {avatarURLInputErrMsg}
            </p>
            <p className={styles.url_suggestion_msg}>
              {t("Recommended minimum size: 200 x 200px.")}
              <br />
              {t("Only JPG, PNG, and GIF files are allowed.")}
            </p>
          </div>
        </section>
        <section
          className={clsx(styles.buttons_section, mobile && styles.mobile)}
        >
          <div className={styles.buttons_container}>
            <ActionButton
              // disabled={formDisabled}
              onClick={handleSubmit}
            >
              {t("Save")}
            </ActionButton>
            <ActionButton
              onClick={preventDefault}
              linkTo={generatePageURI("")}
              // disabled={formDisabled}
            >
              {t("Back to Profile")}
            </ActionButton>
          </div>
          <p
            ref={resultMsgEl}
            className={styles.result_msg}
            style={{ visibility: resultMsg ? "initial" : "hidden" }}
          >
            {resultMsg}
          </p>
        </section>
        <section ref={hostingServicesEl}>
          <h4 className={styles.hosting_heading}>
            {t("Supported Hosting Services")}
          </h4>
          <div className={styles.hosting_services_container}>
            {hostingServices.map(item => {
              return (
                <a
                  className={styles.hosting_service}
                  href={item.url}
                  target="_blank"
                >
                  {item.name}
                </a>
              );
            })}
          </div>
        </section>
        {/* </div> */}
        {/* </fieldset> */}
      </form>
      <Dialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        classes={{
          root: styles.dialog_root
        }}
      >
        <DialogTitle>
          <span className={styles.dialog_title_root}>
            {t("Revert to default image?")}
          </span>
        </DialogTitle>
        <DialogContent>
          {/* <DialogContentText id="alert-dialog-description">
            Revert to default image?
          </DialogContentText> */}
        </DialogContent>
        <DialogActions classes={{ root: styles.dialog_actions_root }}>
          <ActionButton onClick={handleCloseDialog} color="primary">
            {t("No")}
          </ActionButton>
          <ActionButton
            onClick={handleRemoveImgTypeURL}
            color="primary"
            autoFocus
          >
            {t("Yes")}
          </ActionButton>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default function ProfileManagerPage(props) {
  const { match, devUSN, dev } = props;

  const { t, i18n } = useTranslation();

  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [headerData, setHeaderData] = useState();
  const [data, setData] = useState();

  const usn = devUSN ? devUSN : match ? match.params.usn : null;

  // Similar to componentDidMount and componentDidUpdate:
  //
  // https://stackoverflow.com/questions/53120972/how-to-call-loading-function-with-react-useeffect-only-once
  useEffect(() => {
    if (dev) {
      setData({});
    } else {
      axios
        .get(`${profileAPI}?command=profilemanager&ribbon=${window._region === 'BR' ? 2 : 113}`, {
          withCredentials: true
        })
        .then(res => {
          if (
            res.data.APIresult == "000" &&
            res.data.p_o_ErrID == 1 &&
            (window._region === 'BR' ? 
              res.data.dsProfileHasRibbon2[0].HAS == 1 :
              res.data.dsProfileHasRibbon113[0].HAS == 1
            ) &&
            res.data.usnfromcookie[0][""] == usn
          ) {
            setData(
              window._region === 'BR' ? (
                res.data.dsProfileURL2.length > 0
                ? res.data.dsProfileURL2[0]
                : {}
              ) : (
                res.data.dsProfileURL113.length > 0
                ? res.data.dsProfileURL113[0]
                : {}
              )
            );
            axios
              .get(`${headerAPI}&usn=${res.data.usnfromcookie[0][""]}`)
              .then(res => {
                setHeaderData(res.data.dsProfileHeaderInfo[0]);
              });
          } else {
            //redirect to index page
            window.location.href = generatePageURI(pagePaths.MAIN);
          }
        });
    }
  }, []);

  // const MyPageContent = () => {
  // const content = (
  //   <PageContent
  //     usn={usn}
  //     initialBannerURL={initialBannerURL}
  //     initialAvatarURL={initialAvatarURL}
  //     mobile={mobile}
  //   />
  // );

  // return (
  //   <>
  //     {/* desktop */}
  //     <Hidden xsDown>
  //       <Container>
  //         {content}
  //       </Container>
  //     </Hidden>
  //     {/* mobile */}
  //     <Hidden smUp>
  //       <Container maxWidth="sm">
  //         {content}
  //       </Container>
  //     </Hidden>
  //   </>
  // );

  // return (
  //   <>
  //     {/* desktop */}
  //     <Hidden xsDown>
  //       <PageContent
  //         usn={usn}
  //         initialBannerURL={initialBannerURL}
  //         initialAvatarURL={initialAvatarURL}
  //       />
  //     </Hidden>
  //     {/* mobile */}
  //     <Hidden smUp>
  //       <PageContent
  //         usn={usn}
  //         initialBannerURL={initialBannerURL}
  //         initialAvatarURL={initialAvatarURL}
  //         mobile
  //       />
  //     </Hidden>
  //   </>
  // );
  // };

  if (!data) {
    return null;
  }

  return (
    <SubPageTemplate
      headerData={headerData}
      headingLeft={t("Profile Page Manager")}

      // headingRight={`${numberWithCommas(inventoryTotalCount)} Items`}
    >
      <div className={styles.page_container}>
        <PageContent
          // usn={usn}
          // initialBannerURL={initialBannerURL}
          // initialAvatarURL={initialAvatarURL}
          mobile={mobile}
          data={data}
        />
      </div>
    </SubPageTemplate>
  );
}
